import { AsyncResult, useSafeAddress } from "@/hooks";
import { supportedChain } from "@/config/chains";
import { useTxHistory } from "tonkey-gateway-typescript-sdk";
import { POLLING_INTERVAL } from "@/constants";
import { Transaction } from "@/types/tx";

export const useLoadTxHistory = (): AsyncResult<Transaction[]> => {
  const address = useSafeAddress();
  const { chainId } = supportedChain;

  const { data, error, loading } = useTxHistory(address, chainId, POLLING_INTERVAL);

  return [data, error, loading];
};

export default useLoadTxHistory;
